function NotFoundPage() {
    return (        
        <div className="text-center">
            <h1 className="msds-text-lead msds-text-clear-blue mb-10">404 Error</h1>
            <a href="/">Return to integrations</a>
        </div>
    );
}

export default NotFoundPage;
